export interface CertificateAction {
  label: string
  testId: string
  disabled?: boolean
}

/** Sending is only possible once a document exists, so these two are gated on documentPresence. */
export const SEND_DOCUMENT_ACTION = 'certificate-option-send-document'
export const SEND_DOCUMENTS_ACTION = 'certificate-bulk-send-document'
export const SHOW_PREVIEW_ACTION = 'certificate-option-show-preview'

export const CERTIFICATE_OPTION_ACTIONS: readonly CertificateAction[] = [
  { label: 'New Version', testId: 'certificate-option-new-version' },
  { label: 'Duplicate', testId: 'certificate-option-duplicate' },
  { label: 'Activation', testId: 'certificate-option-activation' },
  { label: 'Cancellation', testId: 'certificate-option-cancellation' },
  { label: 'Lessor Requirement', testId: 'certificate-option-lessor-requirement' },
  { label: 'Certificate for Restricted Countries', testId: 'certificate-option-restricted-countries', },
  { label: 'Show Preview', testId: SHOW_PREVIEW_ACTION },
  { label: 'Create Document', testId: 'certificate-option-create-document' },
  { label: 'Send Document', testId: SEND_DOCUMENT_ACTION },
  { label: 'Reminder', testId: 'certificate-option-reminder' },
]

export const BULK_CERTIFICATE_ACTIONS: readonly CertificateAction[] = [
  { label: 'New Version', testId: 'certificate-bulk-new-version' },
  { label: 'Duplicate', testId: 'certificate-bulk-duplicate' },
  { label: 'Activation', testId: 'certificate-bulk-activation' },
  { label: 'Cancellation', testId: 'certificate-bulk-cancellation' },
  { label: 'Create Document', testId: 'certificate-bulk-create-document' },
  { label: 'Send Document', testId: SEND_DOCUMENTS_ACTION }
]
